// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Pltnt","rotateAnimation":"Spinner_rotateAnimation__Bp4SC","dashAnimation":"Spinner_dashAnimation__dDcO4"};